import styled from "styled-components"

export const MenuLi = styled.li`
  margin: 0;
`
